export default __webpack_public_path__ + "static/media/suite-logo.74687f3f.svg";